var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","background":"#fff"},attrs:{"name":"Iframe","frameborder":"0","src":("https://www.khl.top/#/activeData?token=" + _vm.token)}})}
var staticRenderFns = []

export { render, staticRenderFns }